import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchSectionProducts } from 'store/actions';

// Import translation
import { useTranslation } from 'react-i18next';

// Import components
import ProductsSelect from 'components/utilities/products_select/ProductsSelect';

// Import products tabs
import {
	vod,
	audio,
	liveEvents,
	banners,
	collections,
	articles,
	channel
} from 'components/utilities/products_select/helpers/tabs';

const SectionsProducts = ({ data, error, isLoaded, fetchSectionProducts }) => {
	const { t } = useTranslation();
	const tabs = [
		vod,
		audio,
		liveEvents,
		channel,
		banners,
		collections,
		articles
	];

	const createSubmitData = (selectedData) => {
		const selection = { products: [] };

		selection.products = selectedData.map((item, index) => ({
			uuid: item.uuid,
			order: index + 1
		}));

		return selection;
	};

	return (
		<ProductsSelect
			api="section"
			title={t('common:products.title')}
			tabs={tabs}
			openModalText={t('common:products.add_products')}
			buttonSubmitText={t('common:buttons.submit')}
			notificationName="products"
			initialData={data}
			error={error}
			isLoaded={isLoaded}
			fetchResourcesAction={fetchSectionProducts}
			createSubmitData={createSubmitData}
		/>
	);
};

SectionsProducts.propTypes = {
	data: PropTypes.array.isRequired,
	isLoaded: PropTypes.bool.isRequired,
	error: PropTypes.bool.isRequired,
	fetchSectionProducts: PropTypes.func.isRequired
};

const mapStateToProps = ({ sections: { products } }) => {
	return {
		data: products.data,
		isLoaded: products.isLoaded,
		error: products.error
	};
};

export default connect(mapStateToProps, { fetchSectionProducts })(
	SectionsProducts
);
